var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeLogoV3 = function SvgYoutubeLogoV3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535768",
    d: "M23.506 6.529a3.01 3.01 0 0 0-2.116-2.115C19.512 3.9 12 3.9 12 3.9s-7.512 0-9.39.494A3.07 3.07 0 0 0 .494 6.529C0 8.407 0 12.302 0 12.302s0 3.914.494 5.772A3.01 3.01 0 0 0 2.61 20.19c1.897.514 9.39.514 9.39.514s7.512 0 9.39-.494a3.01 3.01 0 0 0 2.116-2.115C24 16.216 24 12.32 24 12.32s.02-3.914-.494-5.792m-13.898 9.37V8.704l6.247 3.599z"
  })));
};
export default SvgYoutubeLogoV3;